import { render, staticRenderFns } from "./PersonPhoneForm.vue?vue&type=template&id=ccece5e2"
import script from "./PersonPhoneForm.vue?vue&type=script&lang=ts"
export * from "./PersonPhoneForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports